/* eslint import/no-webpack-loader-syntax: off */
// Class that represents all 3D scenes.  We take tis approach to avoid rendering multiple
// A-Frame scenes (which is slow)

import React from 'react';

import {AFrameScene} from '../lib/aframe-components'

// import imgaes used in next screens, to ensure a smooth transition.
import vtoLogoImage from '../assets/Text/CART/LOGO.png'
import basketImage from '../assets/Icons/BASKET_ICON.png'
import outOfStockImage from '../assets/Icons/OUT_OF_STOCK.png'
import cartLogo from '../assets/Text/CART/LOGO.png'
import cartTitle from '../assets/Text/CART/CART.png'
import cartCheckoutButton from '../assets/Text/CART/CHECK_OUT.png'
import RevisedLayoutHtml from '!html-loader!./revised-layout.html'

import {
  enableGyro,
  iFrameGyro,
  sceneController,
  clickable,
  classFromSelector,
  virtualRoom,
  objectSet,
  cylindricalPosition,
  sphericalPosition,
  videoPopout,
  videoDisplay,
  screenDisplay,
  inheritTransform,
  aimAssist,
  mouseRelay,
  lookPolaroid,
  productPicker,
  lookProducts,
  productProducts,
  productPanel,
  benefitsPanel,
  clickToAddToCart,
  clickToShowProduct,
  balloonAnimation,
} from '../components/VirtualRoom'

/*import {xrLightComponent,
        xrLightComponentDebug,
        xrLightSystem} from '../components/Lights'*/

// yes, this could be an array... at this stage it's easier just to dump this in
// than figure it out...
const preloadImage1 = new Image();
const preloadImage2 = new Image();
const preloadImage3 = new Image();
const preloadImage4 = new Image();
const preloadImage5 = new Image();
const preloadImage6 = new Image();

const FilterType = {
  CUSTOM_SHADER: 'shader',
  PBR_MATERIAL: 'material',
  TEXTURE: 'texture',
  VIDEO: 'video',
}

const filters = [
   null,
   {
      name: 'Neal Lip (3/3)',
      type: FilterType.PBR,
      resource: '#lips-material1',
    },
    {
      name: 'Neal Lip (3/3)',
      type: FilterType.PBR,
      resource: '#lips-material2',
    },
    {
      name: 'Neal Lip (3/3)',
      type: FilterType.PBR,
      resource: '#lips-material3',
    },
    {
      name: 'Neal Lip (3/3)',
      type: FilterType.PBR,
      resource: '#lips-material4',
    },
    {
      name: 'Neal Lip (3/3)',
      type: FilterType.PBR,
      resource: '#lips-material5',
    },
    {
      name: 'Neal Lip (3/3)',
      type: FilterType.PBR,
      resource: '#lips-material6',
    },
   ]

const updateScene = (chosenPage, sceneClass, selectedShade, yRotation) => {
  const scene = document.querySelector('a-scene')
  if (scene) {
    scene.setAttribute('scene-controller', {page: chosenPage, yrotation: yRotation})
    scene.setAttribute('class-from-selector', {div: `#${sceneClass}`})
  }

  if (chosenPage === 'vto') {
    const lipsMesh = document.querySelector('#meshLips')
    
    if (lipsMesh) {
      const lips = selectedShade;
      if (lips > 0) {

        // apply makeup to lips.
        lipsMesh.removeAttribute('material-resource')
        lipsMesh.setAttribute('material-resource', filters[lips].resource)
      } else {
        lipsMesh.removeAttribute('material-resource')
        lipsMesh.setAttribute('material-resource', '#material-none')
      }
    }
  }
}

// props...
// page: one of "blank", select", "vto"
// updatePage = {updatePage}
// chosenMakeup={chosenMakeup}
// selectedProduct={selectedProduct}
// selectedShade={selectedShade}
// selectProduct={selectProduct}
// selectShade={selectShade}
// applyProduct={applyProduct}
// addToCart = {addToCart}/>
// cartContents = {cartContents}

export function RevisedLayout(props) {

  // show the correct page.
  // screenClass = foreground/background
  // and for the VTO, get the right make-up to match what was selected.
  updateScene(props.page,
    props.sceneClass,
    props.selectedShade,
    props.yRotation)

  // When we move from into the VTO, we treat this as a separate React page.
  // However since the A-Frame scene is not a child of the React page, we can
  // move to a new React page without re-initializing the A-Frame scene.

  // Changing React page will adjust properties of the A-Frame scene, but just adjusting properties
  // does not trigger a full re-render.

  React.useEffect(() => {

    // Images notused in this scene, but used in subsequent scenes.
    // refer to them him to get them pre-loaded so that we can transition quickly to later scenes.
    preloadImage1.src = vtoLogoImage
    preloadImage2.src = basketImage
    preloadImage3.src = outOfStockImage
    preloadImage4.src = cartLogo 
    preloadImage5.src = cartTitle 
    preloadImage6.src = cartCheckoutButton 
    
  })

  const components =
     [
       {name: 'enable-gyro', val: enableGyro},       
       {name: 'iframe-gyro', val: iFrameGyro},       
       {name: 'scene-controller', val: sceneController},
       {name: 'virtual-room', val: virtualRoom},
       {name: 'object-set', val: objectSet},
       {name: 'cylindrical-position', val: cylindricalPosition},
       {name: 'spherical-position', val: sphericalPosition},
       {name: 'clickable', val: clickable},
       {name: 'video-popout', val: videoPopout},
       {name: 'video-display', val: videoDisplay},
       {name: 'screen-display', val: screenDisplay},
       {name: 'inherit-transform', val: inheritTransform},
       {name: 'class-from-selector', val: classFromSelector},
       {name: 'aim-assist', val: aimAssist},
       {name: 'mouse-relay', val: mouseRelay},
       {name: 'look-polaroid', val: lookPolaroid},
       {name: 'product-picker', val: productPicker},
       {name: 'look-products', val: lookProducts},
       {name: 'product-products', val: productProducts},
       {name: 'product-panel', val: productPanel},
       {name: 'benefits-panel', val: benefitsPanel},
       {name: 'click-to-add-to-cart', val: clickToAddToCart},
       {name: 'click-to-show-product', val: clickToShowProduct},
       {name: 'balloon-animation', val: balloonAnimation},
       //{name: 'xr-light-debug', val: xrLightComponentDebug},
       //{name: 'xr-light', val: xrLightComponent},
     ]

  const systems = 
    [
      //{name: 'xr-light', val: xrLightSystem},
    ]

  // The purpose of this div before the A-Frame scene is to give us a channel to pass
  // info about the start page to the scene-controller component *before* the A-Frame scene
  // is initialized.

  // This covers a gap with "updatePage" above, where it can't access the scene on the first render
  // because the scene does not exist yet.

  let availableStock = ""
  props.productStock.forEach((item, index) => {
    const itemStock = item - props.cartContents[index];
    availableStock += `${itemStock},`
  })
  
  return (
    <>
      <div id='background' className='backgroundAFrameScene'></div>
      <div id='foreground' className    ='foregroundAFrameScene'></div>
      <div id='aframe-scene-data' data-page={props.page} data-stock={availableStock}></div>
      <AFrameScene
        components={components}
        systems={systems}
        shaders={null}
        sceneHtml={RevisedLayoutHtml}/>
    </>
  )
}